import {useDispatch} from "react-redux";
import _ from "lodash";
import {userInviteActions} from "_actions";
import {userInviteStatus} from "_constants";
import FilterEntry from "../FilterEntry";
import useGetOrganizations from "../../../views/Proactive/Utilities/hooks/useGetOrganizations";
import InviteStatusFilter from "./InviteStatusFilter";
import {normalizeQueryParam} from "../../../views/UserManagement/Utilities/UserInviteUtils";
import {useUpdateUrlWithFilters} from "../../../views/UserManagement/Utilities/hooks/useUpdateUrlWithFilters";

export default function UserInviteFilter({ handleClose }) {
    const { organizations, loading } = useGetOrganizations();
    const dispatch = useDispatch();
    const searchParams = new URLSearchParams(window.location.search);
    const queryParams = Object.fromEntries(searchParams.entries());
    const updateUrl = useUpdateUrlWithFilters(queryParams);

    const allStatusValues = Object.values(userInviteStatus);
    const organizationsParam = normalizeQueryParam(_.get(queryParams, 'organization'));
    const statusesParam = normalizeQueryParam(_.get(queryParams, 'inviteStatus'));

    const statusObjArr = allStatusValues.map(status => ({
        name: status.charAt(0) + status.slice(1).toLowerCase(),
        value: status
    }));

    const searchWithFilter = (selectedOrganizations, selectedStatuses) => {
        const organization = selectedOrganizations.join(',');
        const inviteStatus = selectedStatuses.join(',');
        const payload = { ...queryParams, organization, inviteStatus };
        const filters = { organization: selectedOrganizations, inviteStatus: selectedStatuses };
        updateUrl(filters);
        dispatch(userInviteActions.list(payload));
    };

    const applyFilters = (selectedOrganizations, selectedStatuses) => {
        searchWithFilter(selectedOrganizations, selectedStatuses);
        handleClose();
    };

    return (
        <FilterEntry
            label="Organization"
            primaryOptions={organizations}
            loadingPrimaryOptions={loading}
            primaryOptionsDefaultValues={organizationsParam}
            secondaryOptions={statusObjArr}
            secondaryOptionsDefaultValues={statusesParam}
            handleApplyFilters={applyFilters}
            SecondaryFilter={InviteStatusFilter}
        />
    );
}
